<template>
  <div class="queItem">
    <InfoItem v-for="(item,index) in list"
              :key="index"
              :itemDada="item"
              class="item"
              @goDetail='goDetail'>
      <div slot="right-icon"
           class="right-icon">
        <span>{{item.answer_number?'已回答':'未回答'}}</span>
      </div>
      <div slot="detail"
           class="ask_content">
        <p class="ask_title">{{item.ask_title}}</p>
        <p v-if="showFrom"
           class="askForm">来自：<span>{{item.chapter_title}}</span> <span> >{{item.periods_title}}</span></p>
      </div>
    </InfoItem>
    <Empty v-if="!list.length"
           :empty_type="{ name: '暂无数据' }"></Empty>
  </div>
</template>

<script>
import InfoItem from '@/components/que_answers/InfoItem'
import Empty from "@/components/Empty";
export default {
  components: {
    InfoItem, Empty
  },
  props: {
    list: {
      type: Array,
      default: () => {
        return [];
      }
    },
    showFrom: {
      type: Boolean,
      default: () => {
        return false;
      }
    }
  },
  data () {
    return {
    };
  },
  created () {
  },
  methods: {
    goDetail (item) {
      this.$emit('goDetail', item);
      // let query = this.$route.query;
      // this.$pub.toAskDetail(query, item);
    }
  }
};
</script>

<style lang="scss" scoped>
.queItem {
  margin-bottom: 20px;
  .item {
    position: relative;
    border-bottom: 1px solid #f6f6f6;
    &:last-child {
      border-bottom: none;
    }
    font-size: 24px;
    color: #999999;
    /deep/.news-content {
      .item_info {
        img {
          margin-top: 6px;
        }
      }
    }
  }
  .right-icon {
    top: 24px;
    right: 20px;
    position: absolute;
    display: inline-block;
    // background-image: url("~@/assets/images/common@2x.png");
    // background-repeat: no-repeat;
    // background-size: 23px 21px;
    padding-left: 40px;
  }
  .ask_content {
    margin-left: 66px;
    .ask_title {
      color: #7c7c7c;
      font-size: 24px;
      margin-top: 21px;
      line-height: 33px;
      @include lines-eps(2);
    }
    .askForm {
      font-size: 24px;
      color: #999999;
      margin-top: 34px;
      span {
        // color: $theme_color;
      }
    }
  }
}
</style>
